import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {InputDebounceTime} from '../../enums/general-enums';

@Component({
  selector: 'gr-search',
  templateUrl: './search.component.html'
})
export class SearchComponent implements OnInit, OnChanges {
  @Input() searchQuery = '';
  @Input() inputClass = '';
  @Input() searchPlaceholder = '';
  @Input() inputClasses = '';
  @Output() searchQueryChange = new EventEmitter<string>();
  searchSubject = new Subject<string>();
  internalSearchQuery = '';

  constructor() {
    this.internalSearchQuery = this.searchQuery;
  }

  ngOnInit(): void {
    this.debounceSearch();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['searchQuery'] && changes['searchQuery'].currentValue !== undefined) {
      this.internalSearchQuery = changes['searchQuery'].currentValue;
    }
  }

  debounceSearch(): void {
    this.searchSubject.pipe(
      debounceTime(InputDebounceTime.time),
      distinctUntilChanged())
      .subscribe(value => {
        this.searchQuery = value;
        this.searchQueryChange.emit(value);
      });
  }
}
